function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M15 33.021h25.576a1.5 1.5 0 1 1 0 3H12V4.5a1.5 1.5 0 0 1 3 0v28.521zM13.5 9a1.5 1.5 0 0 1 0 3h-6a1.5 1.5 0 0 1 0-3h6zM15 42a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7.04-27.117l.899 1.338c.363.541.148 1.233-.482 1.546-.63.312-1.435.127-1.799-.414l-2.594-3.86a.5.5 0 0 1 .015-.58l2.613-3.477c.395-.525 1.21-.675 1.82-.336.612.339.787 1.039.393 1.564l-.997 1.325a1.5 1.5 0 0 1 .457-.07h12a1.5 1.5 0 0 1 0 3h-12c-.112 0-.22-.013-.326-.036zm11.878 9.036H22.365a1.5 1.5 0 0 1 0-3H34.02l-.943-1.255c-.394-.525-.219-1.225.392-1.564.611-.34 1.426-.189 1.82.336l2.614 3.477a.5.5 0 0 1 .015.58l-2.594 3.86c-.364.54-1.17.726-1.799.414-.63-.313-.846-1.005-.482-1.546l.876-1.302zM15 45a6 6 0 1 1 0-12 6 6 0 0 1 0 12z"
});

var SvgCarrierChange = function SvgCarrierChange(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgCarrierChange;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/carrier-change.svg
// module id = 121
// module chunks = 0 1